import {Injectable} from "@angular/core";
import {AddProductToListUseCase} from "@app/core/lists/application/add-product-to-list.use-case";
import {Observable, Subject} from "rxjs";
import {List} from "@app/core/lists/domain/list";
import {GetAllListsUseCase} from "@app/core/lists/application/get-all-lists.use-case";
import {take} from "rxjs/operators";
import {PopupNotifier} from "@app/presentation/components/errors/popup.notifier";
import {onError} from "@app/presentation/rxjs-utils/operators/on-error";
import {createStatusStore} from "@app/presentation/rxjs-utils/create-status-store";
import {onIsLoadingChanges} from "@app/presentation/rxjs-utils/operators/on-is-loading-changes";
import {Product} from "@app/core/product/domain/dtos/product";

@Injectable()
export class AddToListViewModel {

    notifier = new PopupNotifier;

    private successfullyAddedToListSubject = new Subject<List>();
    readonly successfullyAddedToList$ = this.successfullyAddedToListSubject.asObservable();

    private getAllListsStatus = createStatusStore()
    readonly isGetAllListLoading$:Observable<boolean> =  this.getAllListsStatus.isLoading$;

    constructor(
        private getAllListsUseCase: GetAllListsUseCase,
        private addProductToListUseCase: AddProductToListUseCase,
    ) {
    }

    getAllLists(): Observable<List[]> {
        return this.getAllListsUseCase.execute().pipe(
            take(1),
            onIsLoadingChanges(this.getAllListsStatus.setIsLoading),
            onError(error => this.notifier.notifyError(error))
        );
    }

    addProductToList(listId: number, product: Product, quantity: number) {
        this.addProductToListUseCase.execute(listId, product, quantity)
            .pipe(take(1))
            .subscribe({
                next: list => this.successfullyAddedToListSubject.next(list),
                error: error => this.notifier.notifyError(error),
            });
    }
}
